import React from 'react';
import { useHistory } from 'react-router-dom';

const PARAS = [
  '隨著教育部數位轉型及數位證明應用持續發展，證書已逐步從傳統文件電子化，走向兼具可信驗證、安全流通與跨域應用的新型態數位證明。數位證明管理中心以既有教育部電子證書推動成果為基礎，持續整合電子證書、數位憑證及驗證服務，建構更完整且具延展性的數位證明服務體系。',
  '自教育部推動全國大專校院電子學位證書制度以來，相關服務已逐步建立學位證書之數位發行與驗證基礎，並持續拓展至教師證書、語言能力、學程學分及其他專業資格證明。中心在此基礎上，進一步串聯發證、驗證與應用需求，協助不同發證單位建立可信賴的數位證明機制，並支援學校、機關及機構於各類資格審查與證明查驗情境中的應用。',
  '面對數位憑證與數位身分發展趨勢，中心亦持續推動數位學位憑證、數位憑證皮夾及跨平台驗證應用，並關注國際數位憑證標準與跨境互通發展，逐步提升數位證明於升學、就業、資格審查及跨境應用等場域的流通能力，讓數位證明不僅能被發行，更能被安全持有、可信驗證與有效運用。',
  '未來，中心將持續以教育領域為核心，逐步拓展至更多專業發證機構與應用場域，深化數位證明之標準化、可信驗證與跨域互通能力，並透過數位憑證、數位證書及批次驗證等服務，降低各單位導入與應用門檻，逐步形成可持續發展的數位證明服務生態。',
];

export const CenterIntroPage: React.FC = () => {
  const history = useHistory();

  return (
    <>
      <h1>中心介紹</h1>
      <div className="dc-prose">
        {PARAS.map((p, idx) => (
          <p key={idx}>{p}</p>
        ))}
      </div>
      <div className="dc-actions">
        <button
          type="button"
          className="dc-button"
          onClick={() => history.push('/about/architecture')}
        >
          查看服務架構
        </button>
        <button
          type="button"
          className="dc-button"
          onClick={() => history.push('/about/partners')}
        >
          查看合作單位
        </button>
        <button
          type="button"
          className="dc-button"
          onClick={() => history.push('/about/faq')}
        >
          查看常見問題
        </button>
      </div>
    </>
  );
};

export default CenterIntroPage;
